var serverErrorTemplate = require('html/templates/serverError')();
var t = require('js/lib/translate').t;

serverError.$inject = ['$rootScope', 'modal'];

function serverError($rootScope, modal) {

  var message = function(data) {
    var match = data.match(/<h1>(.*?)<\/h1>/);
    var message = match && match[1].replace(/HTTP Status \d+ - /, '');

    return message || data;
  };

  this.error = function(status, statusText, data, title) {
    $rootScope.serverError = {
      status: status,
      statusText: statusText,
      data: (typeof data === 'object') && data,
      message: (typeof data === 'string') ? message(data) : ''
    };

    modal.open({
      scope: $rootScope,
      klass: 'server-error',
      title: t(title || 'generalErrorHeader'),
      body: serverErrorTemplate
    });
  };

  $rootScope.$on('$routeChangeStart', function() {
    $rootScope.serverError = undefined;
  });

}

module.exports = serverError;



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/services/serverError.js
 ** module id = 205
 ** module chunks = 1
 **/